import { Injectable } from "@angular/core";
import {
    CanDeactivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";

@Injectable({
    providedIn: "root",
})
@Injectable()
export class FormGuard implements CanDeactivate<DirtyCheckComponent> {
    canDeactivate(component: DirtyCheckComponent) {
        if (component.canDeactivate()) {
            return true;
        }
        return false;
    }
}
